<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div v-if="taquillero.role != 9 && taquillero.role != 1" class="col-12">
                <div class="form-group">
                    <label for="Role">Roles</label>
                    <ValidationProvider name="role" id=role rules="required" v-slot="{ errors }">
                        <b-form-select
                            v-model="taquillero.role"
                            placeholder="Roles"
                            text-field="nombre"
                            value-field="id"
                            :options="roles"
                            :class="(errors[0] ? 'is-invalid' : '')"
                        ></b-form-select>
                        <span v-if="errors[0]" class="d-block bg-danger text-white mt-1 text-xs" style="padding: 5.5px;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <FormInput label="Email" name="email" id="email" rules="required" v-model="taquillero.email" />
            </div>
            <div class="col-12">
                <FormInput label="Nombre" name="nombre" id="nombre" rules="required" v-model="taquillero.name" />
            </div>
            <div class="col-12">
                <FormInput label="Apellidos" name="apellidos" id="apellidos" rules="required" v-model="taquillero.surnames" />
            </div>
            <div class="col-12">
                <FormInput label="Nif" name="nif" id="nif" rules="required" v-model="taquillero.nif" />
            </div>
            <div class="col-12">
                <FormInput label="Contraseña" type="password" name="password" id="password" rules="confirmed:confirmation" v-model="taquillero.password" />
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="password">Confirmar contraseña</label>
                    <ValidationProvider name="password" vid="confirmation" v-slot="{ errors }">
                        <input type="password" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="password_confirmation" placeholder="Contraseña" v-model="taquillero.password_confirmation">
                        <span id="exampleInputPasswordConfirmation-error" class="error invalid-feedback">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <template v-if="taquillero.permisos">
                <div class="col-12">
                    <h3>Permisos</h3>
                </div>
                <div class="col-12">
                    <hr>
                </div>
                <div class="col-12">
                    <table class="table table-hover text-nowrap">
                        <thead>
                        <tr>
                            <th>Permiso</th>
                            <th class="text-center">Activado</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(permiso, index) in taquillero.permisos">
                            <tr :key="index">
                                <td>{{ permiso.label }}</td>
                                <td class="text-center">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" :id="'customCheckbox-' + index" v-model="taquillero.permisos[index].value">
                                        <label :for="'customCheckbox-' + index" class="custom-control-label"></label>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </template>
            
            <template v-if="taquillero.role === 11">
                <div class="col-12">
                    <h3>Regiones</h3>
                </div>
                <div class="col-12">
                    <hr>
                </div>
                <div class="col-12 mb-5">
                    <multiselect
                        v-model="taquillero.regions"
                        :options="regions"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Seleccione regiones"
                        label="name"
                        track-by="id"
                    ></multiselect>
                </div>
            </template>
            
            <div class="col-12 col-lg-10">
                <div v-if="error" class="alert alert-danger alert-dismissible">
                    <h5><i class="icon fas fa-ban"></i> El email ya esta registrado en el sistema.</h5>
                </div>
            </div>
            <div class="col-12 col-lg-2 text-right">
                <Button type="submit" name="button">CONTINUAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>

export default {
    props: ['taquillero', 'error', 'regions'],
    data() {
        return {
            roles: [
                { id: 8, nombre: 'Taquillero' },
                { id: 10, nombre: 'Entrenador' },
                { id: 11, nombre: 'Taquilla club visitante'}
            ]
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                if(this.taquillero.role === 11){
                    this.taquillero.regions = this.taquillero.regions.map(region => region.id);
                }
                this.terminar();
            }
        },
        terminar() {
            this.$emit('terminado');
        },
    }
}
</script>
